<!--
 * @Author: czj
 * @Date: 2026-06-12 10:00:33
 * @Description: 根组件 — 应用主题色初始化 + 系统配置同步
 * @FilePath: \kp-rag-system\src\App.vue
-->
<template>
  <router-view></router-view>
</template>
<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStorage } from '@vueuse/core'
import { useElementPlusTheme } from 'use-element-plus-theme'
import { useStore } from '@/Store/index'
import { useUserStore } from '@/Store/user'
import { get_project_config } from '@/api/index'

const router = useRouter()
const store = useStore()
const userStore = useUserStore()

// 主题色：优先从 localStorage 初始值，后续由 getSystem_conf() 覆盖
const layoutThemeColor = useStorage('layout-theme-color', '#243db9')
const { changeTheme } = useElementPlusTheme(layoutThemeColor.value)

onMounted(async () => {
  // 等待路由守卫完成（守卫中 getSystem_conf 已调用）
  await router.isReady()

  // 守卫已加载配置 → 直接应用
  if (userStore.project_info?.theme_color) {
    changeTheme(userStore.project_info.theme_color)
    store.setSystemConfig(userStore.project_info)
    return
  }

  // 兜底：未登录等守卫未调 system_conf 的情况
  try {
    const res = await get_project_config()
    if (res) {
      store.setSystemConfig(res)
      if (res.theme_color) {
        changeTheme(res.theme_color)
      }
    }
  } catch (e) {
    console.error('获取项目配置失败:', e)
  }

  // 二次同步：从 localStorage 读取（路由守卫写入的备份）
  const systemConfigStr = localStorage.getItem('system_config')
  if (systemConfigStr) {
    try {
      const config = JSON.parse(systemConfigStr)
      if (config.theme_color) {
        changeTheme(config.theme_color)
      }
      if (!store.systemConfig || Object.keys(store.systemConfig).length === 0) {
        store.setSystemConfig(config)
      }
    } catch (e) {
      // ignore
    }
  }
})
</script>
<style scoped></style>
